'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationItem = function NavigationItem(_ref) {
  var linkDisplay = _ref.linkDisplay,
      href = _ref.href,
      role = _ref.role,
      tabIndex = _ref.tabIndex,
      children = _ref.children,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-navigation-item' },
    _react2.default.createElement(
      'a',
      {
        className: 'quiver-navigation-item__container__link',
        href: href,
        role: role,
        tabIndex: tabIndex,
        onClick: href ? null : onClick
      },
      linkDisplay
    ),
    children
  );
};

NavigationItem.propTypes = {
  linkDisplay: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  href: _propTypes2.default.string,
  role: _propTypes2.default.string,
  tabIndex: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};

NavigationItem.defaultProps = {
  href: null,
  role: null,
  tabIndex: null,
  children: null,
  onClick: null
};

exports.default = NavigationItem;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NavigationItem/NavigationItem.js
// module id = 297
// module chunks = 0